export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-4.0108ddac.png";